export const REQUEST_TIMEOUT = 30000;
export const BATCH_REQUEST_ID = 35508;
